<template>
    <div class="user-not-found">
        <div class="user-not-found__wrapper">
            <h1>Oops!</h1>
            <p>
                It appears that you do not have sufficient permissions to log in to this platform.
                <br />
                Please click
                <a
                    target="_blank"
                    rel="noopener"
                    href="https://jira.uhub.biz/servicedesk/customer/portal/4408/create/24102"
                    ><strong>here</strong></a
                >
                to request access.
            </p>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { ApolloQueryResult } from "@apollo/client/core";

import meQuery from "@/apollo/queries/Me.gql";
import type { Me } from "@/store/modules/auth";
import { AppRouteNames } from "@/router/constants";

export default defineComponent({
    name: "UserNotFound",

    apollo: {
        me: {
            query: meQuery,
            pollInterval: 5000,
            fetchPolicy: "no-cache",
            result({ data, error }: ApolloQueryResult<{ me?: Me }>) {
                if (!error && data.me) {
                    void this.$router.replace({ name: AppRouteNames.HOME });
                }
            }
        }
    }
});
</script>

<style lang="scss" scoped>
.user-not-found {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80vh;
    text-align: center;

    .user-not-found__wrapper {
        margin: 50px auto;
        text-align: center;

        h1 {
            font-size: 32px;
            margin-bottom: 25px;
        }

        p {
            font-size: 14px;
            margin: 10px 0;
        }
    }
}
</style>
